module.exports = __webpack_public_path__ + "static/media/Hyunmin Cheong.7cfcb11f.png";